import { Component } from '@angular/core';

@Component({
  selector: 'app-admin-footer',
  imports: [],
  templateUrl: './admin-footer.component.html',
  styleUrl: './admin-footer.component.scss'
})
export class AdminFooterComponent {
  protected readonly currentYear = new Date().getFullYear();
}
